/**
 * Clic vs arrastre en tarjetas Pipeline (HTML5 drag).
 * Un movimiento mínimo cancela el `click` nativo; en ese caso abrimos en `dragEnd`
 * si el gesto fue corto (no un drop a otra columna).
 */
import { useRef, useCallback } from "react";

export const PIPELINE_CARD_CLICK_SLOP_PX = 14;

export function usePipelineCardClickDrag(onOpen, onDragStartOuter) {
  const ptr = useRef({ x: 0, y: 0, drag: false, opened: false });

  const tryOpen = useCallback(
    (e) => {
      if (ptr.current.opened) return;
      const t = e?.target;
      if (t && typeof t.closest === "function" && t.closest("[data-pipeline-no-click]")) {
        return;
      }
      ptr.current.opened = true;
      onOpen?.(e);
    },
    [onOpen]
  );

  const onMouseDown = useCallback((e) => {
    if (e.button !== 0) return;
    ptr.current = { x: e.clientX, y: e.clientY, drag: false, opened: false };
  }, []);

  const onDragStart = useCallback(
    (e) => {
      ptr.current.drag = true;
      onDragStartOuter?.(e);
    },
    [onDragStartOuter]
  );

  const onDragEnd = useCallback(
    (e) => {
      const { x, y, drag } = ptr.current;
      if (!drag) return;
      const dx = Math.abs(e.clientX - x);
      const dy = Math.abs(e.clientY - y);
      // Micro-drag / gesto abortado: el navegador no dispara click → abrir aquí.
      if (dx <= PIPELINE_CARD_CLICK_SLOP_PX && dy <= PIPELINE_CARD_CLICK_SLOP_PX) {
        tryOpen(e);
      }
      ptr.current.drag = false;
    },
    [tryOpen]
  );

  const onClick = useCallback(
    (e) => {
      // Click limpio (sin dragstart). Si ya abrimos en dragEnd, no duplicar.
      if (ptr.current.drag) return;
      tryOpen(e);
    },
    [tryOpen]
  );

  return { onMouseDown, onDragStart, onDragEnd, onClick };
}
